import { formatString } from "@/helpers/formatting";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { CheckoutTemplate, CheckoutTemplateBase } from "@/models/checkout";
import type { IPaginatedResponse } from "@/models/common";

class CheckoutTemplateService {
  async create(template: CheckoutTemplate) {
    const response = await axiosClient<{ data: CheckoutTemplate }>({
      method: "POST",
      url: endpoints.CHECKOUT_TEMPLATES.ALL,
      data: template,
    });

    return response.data.data;
  }

  async getAll(params?: Record<string, unknown>) {
    const response = await axiosClient<
      IPaginatedResponse<CheckoutTemplateBase>
    >({
      method: "GET",
      url: endpoints.CHECKOUT_TEMPLATES.ALL,
      params,
    });

    return { templates: response.data.data, meta: response.data.meta };
  }

  async getById(id: string) {
    const response = await axiosClient<{
      data: CheckoutTemplate & { id: string };
    }>({
      method: "GET",
      url: formatString(endpoints.CHECKOUT_TEMPLATES.SINGLE, id),
    });

    return response.data.data;
  }

  async update(template: CheckoutTemplate) {
    const url = formatString(
      endpoints.CHECKOUT_TEMPLATES.SINGLE,
      template.id ?? ""
    );

    const response = await axiosClient<{
      data: CheckoutTemplate & { id: string };
    }>({
      method: "PUT",
      url,
      data: template,
    });

    return response.data.data;
  }

  async deleteById(id: string) {
    await axiosClient({
      method: "DELETE",
      url: formatString(endpoints.CHECKOUT_TEMPLATES.SINGLE, id),
    });
  }
}

const checkoutTemplateService = new CheckoutTemplateService();
export default checkoutTemplateService;
